import { FC, useEffect } from 'react';
import useTrainingHopSentence from '../../hooks/useTrainingHopSentence';
import DisplayParagraph from '../Atoms/DisplayParagraph';

// Hopのセンテンス情報
type HopSentence = {
  // テキスト
  text: string;
  // 開始時間
  startTime: number;
  // 終了時間
  endTime: number;
};

type Props = {
  // 現在の再生時間
  currentTime: number;
  // 英語のセンテンス
  englishSentence: HopSentence;
  // 日本語のセンテンス
  japaneseSentence: HopSentence | null;
};

const TrainingHopSentence: FC<Props> = ({
  currentTime,
  englishSentence,
  japaneseSentence,
}) => {
  const {
    isEnglishVisible,
    updateIsEnglishVisible,
    isJapaneseVisible,
    updateIsJapaneseVisible,
  } = useTrainingHopSentence({
    english: {
      startTime: englishSentence.startTime,
      endTime: englishSentence.endTime,
    },
    japanese: japaneseSentence
      ? {
          startTime: japaneseSentence.startTime,
          endTime: japaneseSentence.endTime,
        }
      : null,
  });

  useEffect(() => {
    updateIsEnglishVisible(currentTime);
  }, [updateIsEnglishVisible, currentTime]);

  useEffect(() => {
    updateIsJapaneseVisible(currentTime);
  }, [updateIsJapaneseVisible, currentTime]);

  return (
    <>
      <DisplayParagraph
        isVisible={isEnglishVisible}
        text={englishSentence.text}
      />
      <DisplayParagraph
        isVisible={isJapaneseVisible}
        text={japaneseSentence ? japaneseSentence.text : ''}
      />
    </>
  );
};

export default TrainingHopSentence;
